
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import {
  getAccountStatistic,
  getProductInfo
} from '@/api/product/productAccount'

@Component({
  name: 'usdtExtra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    reuse_address: false,
    collect_by_stake: false,
    show_paid_button: [],
    not_reuse_address: [],
    reuse_address_days: ''
  }
  private reuseAddress: boolean = false
  private collectStake: boolean = false
  private reuseAddressDays: any = '60'

  private reuseAddressCount: any = null

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  // Reuse Deposit Address
  private async noReuseAddress() {
    try {
      this.flag = true
      const data: any = {
        id: this.product.id,
        extra_param: {
          reuse_address: this.extraParam.reuse_address,
          reuse_address_days: this.extraParam.reuse_address_days
        }
      }
      await setProductInfo(data).then(() => {
        this.$message({
          message: 'Edit success',
          type: 'success'
        })
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // Not Reuse Deposit Address
  private addCmReuseAddress() {
    this.extraParam.not_reuse_address.push('')
  }
  private removeCmReuseAddress(index: any) {
    this.extraParam.not_reuse_address.splice(index, 1)
  }
  private async noNotReuseAddress() {
    try {
      // 清空未输入
      this.extraParam.not_reuse_address =
        this.extraParam.not_reuse_address.filter(item => item !== '')
      this.flag = true
      const data: any = {
        id: this.product.id,
        extra_param: {
          not_reuse_address: this.extraParam.not_reuse_address
        }
      }
      await setProductInfo(data).then(() => {
        this.$message({
          message: 'Edit success',
          type: 'success'
        })
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // Collect By Stake
  private async noCollectStake() {
    try {
      this.flag = true
      const data: any = {
        id: this.product.id,
        extra_param: {
          collect_by_stake: this.extraParam.collect_by_stake
        }
      }
      await setProductInfo(data).then(() => {
        this.$message({
          message: 'Edit success',
          type: 'success'
        })
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // Show Paid Button
  private addCmPaidBtm() {
    this.extraParam.show_paid_button.push('')
  }
  private removeCmPaidBtm(index: number) {
    this.extraParam.show_paid_button.splice(index, 1)
  }
  private async noProductPaidBtm() {
    // 清空未输入
    this.extraParam.show_paid_button = this.extraParam.show_paid_button.filter(
      item => item !== ''
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        show_paid_button: this.extraParam.show_paid_button
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res) {
        this.extraParam = {
          reuse_address: res.extra_param.reuse_address,
          collect_by_stake: res.extra_param.collect_by_stake,
          show_paid_button: res.extra_param.show_paid_button,
          not_reuse_address: res.extra_param.not_reuse_address,
          reuse_address_days: res.extra_param.reuse_address_days
        }
        if (!this.extraParam.show_paid_button) {
          this.extraParam.show_paid_button = []
        }
        if (!this.extraParam.not_reuse_address) {
          this.extraParam.not_reuse_address = []
        }
      } else {
        this.extraParam = {
          reuse_address: false,
          collect_by_stake: false,
          show_paid_button: [],
          not_reuse_address: [],
          reuse_address_days: ''
        }
      }
    })
  }

  private totalPayment: any = []
  private totalChoice: any = []
  private async getData() {
    try {
      const data: any = {
        id: this.product.id
      }
      await getAccountStatistic(data).then((res: any) => {
        this.totalPayment = res.total_payment
        this.totalChoice = res.total_choice
        this.reuseAddressCount = res.reuse_address_count
      })
    } catch (e) {}
  }

  mounted() {
    this.getData()
    this.getInfo()
  }
}
